import { Typography, Box, Button } from "@mui/material";
import Layout from "../../../components/Layout";
import styles from "../../index.module.scss";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableComponent from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, appActions } from "../../../store/app";
import AddIcon from "@mui/icons-material/Add";
import Storage from "../../../utils/storage";
import LoadingContainer from "../../../components/LoadingContainer";
import { useTranslation } from "../../../i18n";
import PopupMenu from "../../../components/PopupMenu";
import ConfirmModal from "../../../components/ConfirmModal";
import { deleteAction, updateAction } from "../../../store/app/appActions";
import SearchComponent from "../../../components/SearchComponent";
import ChipComponent, { ChipData } from "../../../components/ChipComponent";
import { LoadingButton } from "@mui/lab";
import { businessActions, BusinessState } from "../../../store/business";
import {
  exportSalesAction,
  getSalesAction,
  searchSalesAction,
} from "../../../store/business/sales/salesActions";
import {
  Sale,
  salesColumns,
  SalesRow,
} from "../../../interfaces/Business/sales";
import { deleteSalesService } from "../../../store/business/sales/salesService";
import { numberWithCommas } from "../../../utils/functions";
import AddSales from "./AddSales";
import SalesView from "./SalesView";
import FilterSales from "./FilterSales";

const Sales = () => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [query, setQuery] = useState("");
  const [isInit, setIsInit] = useState(true);
  const dispatch = useDispatch();
  const appState: AppState = useSelector((state: any) => state.app);
  const businessState: BusinessState = useSelector(
    (state: any) => state.business
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipData, setChipData] = useState([]);
  const [sales, setSales] = useState<any>();
  const [viewSales, setViewSales] = useState<boolean>();
  const open = Boolean(anchorEl);
  const token = Storage.getToken();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      getSalesAction(`?page=${page}&sort=-date&limit=${rowsPerPage}`, token)
    );
  }, []);

  useEffect(() => {
    if (!businessState.fetchedSales) {
      dispatch(
        getSalesAction(
          `?page=${page}&sort=-createdAt&limit=${rowsPerPage}${query}`,
          token
        )
      );
    }
  }, [businessState.fetchedSales]);

  useEffect(() => {
    if (!appState.isFetching) {
      setCount(appState.count);
    }
  }, [appState.isFetching, appState.count]);

  useEffect(() => {
    if (chipData.length > 0) {
      let queryString = "";
      chipData.forEach((data: any) => {
        queryString += `&${data.id}=${data.filter}`;
      });
      setQuery(queryString);
      dispatch(businessActions.setFetchedSales(false));
    } else if (chipData.length === 0 && query !== "") {
      setQuery("");
      dispatch(businessActions.setFetchedSales(false));
    }
  }, [chipData]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (searchText) {
        dispatch(searchSalesAction(`?text=${searchText}`, token));
        setIsInit(false);
      } else {
        if (!appState.isFetching && !isInit) {
          dispatch(businessActions.setFetchedSales(false));
        }
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [searchText]);

  const createData = (sales: Sale): SalesRow => {
    return {
      date: sales.date.substring(0, 10),
      client: sales.client?.name,
      pig: sales.pig?.earTag,
      weight: `${sales?.weight} Kg`,
      price: `${numberWithCommas(sales.unitPrice * sales?.weight)} RWF`,
      action: (
        <button
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setSales(sales);
            console.log("salesss ", sales);
            setAnchorEl(event.currentTarget);
          }}
          className={styles.actionsIcon}
        >
          •••
        </button>
      ),
    };
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(businessActions.setFetchedSales(false));
  };

  const filterHandler = (filterData: any) => {
    setChipData(filterData);
  };

  const handleChipDelete = (chipToDelete: ChipData) => {
    setChipData((chips) =>
      chips.filter((chip: ChipData) => chip.key !== chipToDelete.key)
    );
  };

  const exportExcelHandler = () => {
    dispatch(exportSalesAction("?limit=1000", token, t("sales")));
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(businessActions.setFetchedSales(false));
  };

  const deletesalesHandler = () => {
    dispatch(
      updateAction(
        deleteSalesService,
        sales?._id,
        sales,
        token,
        () => {},
        () => {
          dispatch(appActions.setIsDeleting(false));
          dispatch(businessActions.setFetchedSales(false));
        }
      )
    );
  };

  const rows = businessState?.sales?.map((sales: Sale) => createData(sales));

  return (
    <>
      <Box className={styles.topContainer}>
        <Box>{t("welcome")}</Box>
        <Box className={styles.dFlex}>
          <SearchComponent setSearchText={setSearchText} />
          <LoadingButton
            variant="contained"
            startIcon={<SaveAltIcon />}
            loading={appState.isExportingExcel}
            onClick={exportExcelHandler}
            className={styles.exportExcelButton}
          >
            {t("exportExcel")}
          </LoadingButton>
        </Box>
      </Box>
      {appState.isFetching && <LoadingContainer />}
      {!appState.isFetching && (
        <>
          {chipData.length > 0 && (
            <ChipComponent
              chipData={chipData}
              handleDelete={handleChipDelete}
            />
          )}
          <Box className={styles.tableTopActions}>
            <Box>
              <Typography>{t("sales")}</Typography>
            </Box>
            <Box>
              <Button
                onClick={() => dispatch(appActions.setOpenFilter(true))}
                startIcon={<AddIcon />}
              >
                {t("filter")}
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    appActions.setOpenForm({ open: true, action: "add" })
                  )
                }
                startIcon={<AddIcon />}
              >
                {t("addNew")}
              </Button>
            </Box>
          </Box>
          <TableComponent
            rows={rows}
            columns={salesColumns}
            count={count}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={handlePageChange}
            handleRowsPerPageChange={handleRowsPerPageChange}
          />
          {open && (
            <PopupMenu
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              onView={() => setViewSales(true)}
              onUpdate={() =>
                dispatch(
                  appActions.setOpenForm({ open: true, action: "update" })
                )
              }
              onDelete={() => dispatch(appActions.setIsDeleting(true))}
            />
          )}
          {appState.isDeleting && (
            <ConfirmModal
              onConfirm={() => deletesalesHandler()}
              content={`${t("confirmDeleteDesc")} gucuruza ${
                sales?.pig?.earTag
              } kuri ${sales?.client?.name} ?`}
            />
          )}
          {appState.openForm.open && <AddSales sales={sales} />}
          {appState.openFilter && (
            // eslint-disable-next-line react/jsx-no-undef
            <FilterSales
              open={appState.openFilter}
              close={() => dispatch(appActions.setOpenFilter(false))}
              filterHandler={filterHandler}
            />
          )}
          {viewSales && (
            <SalesView
              open={viewSales}
              onClose={() => setViewSales(false)}
              sales={sales}
            />
          )}
        </>
      )}
    </>
  );
};

export default Sales;
